function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import classnames from 'classnames';
import { IconCloseThin } from "../Icons";
import injectStyles from "../jss";
import ReactModal from 'react-modal';
import styles from "./Modal.jss";
export var CONTENT_CLASS = 'ReactModal__Content';
export var OVERLAY_CLASS = 'ReactModal__Overlay';
var HIDDEN = 'hidden';
var VISIBLE = 'visible';
var BODY = 'body';
export var Modal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
      var onClose = _this.props.onClose;

      _this.setOverflow(VISIBLE);

      onClose();
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "setOverflow",
    value: function setOverflow(passedOverflow) {
      var overflow = this.props.overflow; // $FlowFixMe

      var newOverflow = passedOverflow || overflow;
      var appElement = this.getAppElement();

      if (appElement) {
        appElement.style.overflow = newOverflow;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var isModalOpen = this.props.isModalOpen;
      this.setOverflow(isModalOpen ? HIDDEN : VISIBLE);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setOverflow(VISIBLE);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isModalOpen = this.props.isModalOpen;

      if (isModalOpen !== prevProps.isModalOpen) {
        this.setOverflow(isModalOpen ? HIDDEN : VISIBLE);
      }
    }
  }, {
    key: "getAppElement",
    value: function getAppElement() {
      var overflowTarget = this.props.overflowTarget;

      if (typeof window === 'undefined') {
        return null;
      }

      if (overflowTarget === BODY) {
        return window.document.body;
      }

      return window.document.getElementById(overflowTarget);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          overlayClassName = _this$props.overlayClassName,
          contentLabel = _this$props.contentLabel,
          innerContentClassName = _this$props.innerContentClassName,
          isModalOpen = _this$props.isModalOpen,
          showDismissButton = _this$props.showDismissButton;
      return React.createElement(ReactModal, {
        appElement: this.getAppElement(),
        contentLabel: contentLabel,
        isOpen: isModalOpen,
        onRequestClose: this.handleClose,
        className: classnames(CONTENT_CLASS, className),
        overlayClassName: classnames(OVERLAY_CLASS, overlayClassName)
      }, showDismissButton && React.createElement("span", {
        onClick: this.handleClose,
        className: classes.closeButton
      }, React.createElement(IconCloseThin, {
        className: classes.closeIcon
      })), React.createElement("div", {
        className: classnames(classes.innerContent, innerContentClassName)
      }, children));
    }
  }]);

  return Modal;
}(React.PureComponent);

_defineProperty(Modal, "styleRoot", 'Modal');

_defineProperty(Modal, "defaultProps", {
  contentLabel: '',
  isModalOpen: false,
  overflow: HIDDEN,
  overflowTarget: BODY,
  showDismissButton: true
});

export default injectStyles(styles)(Modal);